import { hasTier, StaffRole } from './staffRole';
import { useStaffRole } from './useStaffRole';

/**
 * Advisory UX gate (COR-545): resolves whether the signed-in staff member's tier
 * meets `requiredTier`, combining `useStaffRole()` with the shared hierarchical
 * `hasTier` check. Returns `false` when the caller has no tier (fail closed). The
 * backend remains the authorization boundary — this only mirrors it for UX.
 */
export function useCanAccess(requiredTier: StaffRole): boolean {
  return hasTier(useStaffRole(), requiredTier);
}
